import logoPunto99 from '@/assets/logo_punto99.svg';

import { DispatchPlacesSection } from './sections/dispatch-places-section';
import { OrdersAtPlaceSection } from './sections/orders-at-place-section';
import { PendingPayoutsSection } from './sections/pending-payouts-section';
import { useHomePage } from './use-home-page';

/**
 * Main operational dashboard.
 * Composes three independent sections: dispatch place map + KPIs,
 * pending payouts callout, and orders currently held at a place.
 */
export function HomePage() {
  const {
    place_summary,
    places,
    orders_at_place,
    orders_at_place_count,
    pending_payouts,
    finance_currency,
    is_loading,
    is_fetching,
  } = useHomePage();

  if (is_loading && !place_summary) {
    return (
      <div className="flex justify-center p-16">
        <span className="loading loading-spinner loading-lg text-primary" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-8">
      {/* Header */}
      <header className="flex items-center gap-3">
        <img src={logoPunto99} alt="punto99" className="h-7" />
        <span className="text-base-content/30 text-lg">·</span>
        <span className="text-base-content/60 text-sm">Panel operacional</span>
      </header>

      {/* Dispatch places map + summary */}
      <DispatchPlacesSection
        summary={place_summary}
        places={places}
        is_loading={is_fetching}
      />

      {/* Two-column row: payouts + orders at place */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <PendingPayoutsSection amount={pending_payouts} currency={finance_currency} />
        <OrdersAtPlaceSection orders={orders_at_place} total_count={orders_at_place_count} />
      </div>
    </div>
  );
}
